import React from 'react';
import Grid from '@mui/material/Grid';
import FilterContainer from 'Containers/FilterContainer';
import Search from 'Components/Search';
import Dropdown from 'Components/DropDown';
import Toogle from 'Components/Toogle';
import { searchGridStyle, dropdownGridStyle } from './FiltersBar.styled';

export interface FiltersBarPropsI {
  searchPlaceholder: string;
  categoryTitle: string;
  statusTitle: string;
  categories: string[];
  statusOptions: string[];
  isCard: boolean;
  onNameChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onToggleView: (value: boolean) => void;
}

export default function FiltersBar({
  searchPlaceholder,
  categoryTitle,
  statusTitle,
  categories,
  statusOptions,
  isCard,
  onNameChange,
  onCategoryChange,
  onStatusChange,
  onToggleView,
}: FiltersBarPropsI) {
  return (
    <FilterContainer>
      <Grid item xs={4} style={searchGridStyle}>
        <Search placeholder={searchPlaceholder} setData={onNameChange} />
      </Grid>
      <Grid item xs={8} style={dropdownGridStyle}>
        {/* DropDown antepone "Todos" (Generic.All) y regresa '' al elegirla;
            el hook interpreta '' como "sin filtro". */}
        <Dropdown title={categoryTitle} setData={onCategoryChange} options={categories} />
        <Dropdown title={statusTitle} setData={onStatusChange} options={statusOptions} />
        <Toogle value={isCard} onclick={onToggleView} />
      </Grid>
    </FilterContainer>
  );
}
